import styled from "styled-components";
import { Paragraph, Heading } from "../../atoms/Typography/Typography.styles";

interface TestimonialProps {
  colorScheme: string;
  withBackground: boolean;
}

export const Testimonial = styled.div`
  
`

export const TestimonialImageWrapper = styled.div`
  width: 100%;
  border-radius: ${({ theme }) => theme.rem(8)};
  position: relative;
  aspect-ratio: 6 / 4;
  overflow: hidden;

  ${({ theme }) => theme.mediaQuery.xl(`
    width: 98%;
    margin-left: auto;
  `)};

  img {
    object-fit: cover;
    object-position: center;
  }
`

export const TestimonialImageCaption = styled.div<TestimonialProps>`
  padding-left: ${({ theme }) => theme.rem(16)};

  ${Paragraph},
  ${Heading} {
    color: ${({ theme, colorScheme, withBackground }) => withBackground ? theme.colorScheme[`${colorScheme}`].surface.text.base.negative : 'black'};
  }
`

export const TestimonialAuthorWrapper = styled.div`
  padding: ${({ theme }) => theme.rem(60, 0, 24)};
  position: relative;

  ${({ theme }) => theme.mediaQuery.xl(`
    padding: ${theme.rem(98, 192, 16, 16)};
  `)}
`

export const TestimonialAuthor = styled.div<TestimonialProps>`
  ${Paragraph},
  ${Heading} {
    color: ${({ theme, colorScheme, withBackground }) => withBackground ? theme.colorScheme[`${colorScheme}`].surface.text.base.negative : 'black'};
  }
`

export const TestimonialQuoteWrapper = styled.div`

`

export const TestimonialAuthorImage = styled.div`
  position: relative;
  max-height: ${({ theme }) => theme.rem(500)};
  overflow: hidden;
  border-radius: ${({ theme }) => theme.rem(130)};
  aspect-ratio: 2 / 3;
  z-index: 2;

  img {
    object-fit: cover;
    object-position: center;
  }
`

export const TestimonialAuthorIcon = styled.div`
  position: absolute;
  top: 0;
  right: ${({ theme }) => theme.rem(-16)};
  z-index: 1;

  ${({ theme }) => theme.mediaQuery.md(`
    right: 0;
  `)}
  
  i {
    font-size: ${({ theme }) => theme.rem(260)};

    ${({ theme }) => theme.mediaQuery.xl(`
      font-size: ${theme.rem(420)};
    `)}
  }
`